import * as React from 'react';
import clsx from 'clsx';
import { Base, Text } from '../../components/Base';
import Svg from '../../components/Svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "TitleCell-root_1gapG",
  "iconWrapper": "TitleCell-iconWrapper_2jco9",
  "icon": "TitleCell-icon_2DTd5"
};
function TitleCell({
  children,
  icon,
  iconTheme = 'anthracite',
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Base, {
    flex: true,
    flexGrow1: true,
    paddingY: "xsmall",
    paddingX: "small",
    flexAlignItemsCenter: true,
    className: clsx(styles.root, className),
    ...extraProps,
    children: /*#__PURE__*/_jsxs(Base, {
      tagName: "h3",
      flex: true,
      flexAlignItemsStart: true,
      margin: "none",
      size: "big",
      weight: "semibold",
      children: [icon && /*#__PURE__*/_jsx(Base, {
        flex: true,
        flexShrink0: true,
        flexAlignItemsCenter: true,
        className: styles.iconWrapper,
        children: /*#__PURE__*/_jsx(Svg, {
          name: icon,
          theme: iconTheme,
          className: styles.icon
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: children
      })]
    })
  });
}
export default TitleCell;